define('modules/content_recommendations/modal/auto_publish_settings_modal',[
  'backbone',
  '_',
  './auto_publish_settings_model',
  'text!./auto_publish_settings_modal.html',
  'modules/form/form_item_model',
  'modules/form/switch_view',

], function (Backbone, _, AutoPublishSettingsModel, modal_template, FormItemModel, SwitchView) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      this.dataModel = new Backbone.Model();

      _.extend(this, opts);

      this.autoPublishSettingsModel = new AutoPublishSettingsModel({ campaignType: opts.campaignType });
      this.listenTo(
        this.autoPublishSettingsModel,
        'sync',
        function () {
          this.renderZoneAndPlayerList();
        },
        this
      );
      this.autoPublishSettingsModel.fetch();

      this.render();
    },

    hasSidebar: false,

    subViews: [],
    tagName: 'div',
    className: 'auto-publish-settings-modal',
    template: _.template(modal_template),
    allzoneIds: [],

    events: {
      'click .js-cancel': 'closeModal',
      'click .js-edit-auto-publish-settings': 'editAutoPublishSettings',
    },

    render: function () {
      this.$el.html(this.template());
      return this;
    },

    renderZoneAndPlayerList: function () {
      var filterType = this.autoPublishSettingsModel.get('filterType');
      var targetBy;
      switch(filterType) {
        case 0:
          targetBy = 'zones';
          break;
        case 1:
          targetBy = 'players';
          break;
      }
      var field = this.autoPublishSettingsModel.get('section').fields[0];
      var players = this.autoPublishSettingsModel.get('section').fields[0].parts[0].fields[2].options;      
      var zones = this.autoPublishSettingsModel.get('section').fields[0].parts[1].fields[1].options;

      this.allPlayerIds = _.map(players, function (player) {
        return player.value;
      });
      this.allZoneIds = _.map(zones, function (zone) {
        return zone.value;
      });

      var switchView = new SwitchView({
        model: new FormItemModel({
          name: field.name,
          type: field.type,
          label: field.label,
          parts: field.parts,
          targetBy: targetBy,
        }),
        dataModel: this.dataModel,
      });
      this.$el.find('.js-zone-players-list').append(switchView.$el);
    },

    editAutoPublishSettings: function (e) {
      e.preventDefault();

      var activePart = document.querySelectorAll('.button-menu__button.js-switch-target-by.active')[0].getAttribute('data-part');

      var saveIds;
      var filterType;
      if (activePart === 'players') {
        var unexcludedPlayers = this.allPlayerIds;
        if (typeof this.dataModel.get('players') !== 'undefined') {
          unexcludedPlayers = this.dataModel.get('players');
        }
        var playerIds = [];
        if (typeof unexcludedPlayers !== 'undefined') {
            unexcludedPlayers = unexcludedPlayers.map(Number);
            playerIds = this.allPlayerIds.filter(function (playerId, index, arr) {
            return !unexcludedPlayers.includes(playerId);
          });
        }
        else {
          playerIds = this.allPlayerIds;
        }
        saveIds = { 'playerIds': playerIds };
        filterType = { 'filterType': '1' };
      }
      else if (activePart === 'zones') {
        var unexcludedZones = this.allZoneIds;
        if (typeof this.dataModel.get('zones') !== 'undefined') {
          unexcludedZones = this.dataModel.get('zones');
        }
        var zoneIds = [];
        if (typeof unexcludedZones !== 'undefined') {
          unexcludedZones = unexcludedZones.map(Number);
          zoneIds = this.allZoneIds.filter(function (zoneId, index, arr) {
            return !unexcludedZones.includes(zoneId);
          });
        } else {
          zoneIds = this.allZoneIds;
        }
        saveIds = { 'zoneIds': zoneIds };
        filterType = { 'filterType': '0' };
      }

      this.autoPublishSettingsModel.set(saveIds);
      this.autoPublishSettingsModel.set(filterType);
      this.autoPublishSettingsModel.unset('zones');
      this.autoPublishSettingsModel.unset('players');
      this.autoPublishSettingsModel.save(null, { type: 'PUT' });
      this.trigger('close');
    },

    closeModal: function (e) {
      if (e) {
        e.preventDefault();
      }
      this.trigger('close');
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

